import React from "react"

import { DeleteProductPositionOverlayView } from "./DeleteProductPositionsOverlayView"
import { DeleteProductPositionsOverlayModel } from "./hooks/useDeleteProductPositionsOverlayModel"

export const DeleteProductPositionsOverlay = React.memo(
  (props: DeleteProductPositionsOverlayModel) => (
    <DeleteProductPositionOverlayView {...props} />
  )
)
